import { makeAutoObservable, runInAction } from 'mobx';
import get from 'lodash/get';
import { isMobile } from 'react-device-detect';

class AppState {
    isReady = false;

    isRequest = false;

    currentLanguage = 'en';

    isSidebarOpened = !isMobile;

    isRightSidebarOpened = false;

    notificationStatus = (Notification && Notification.permission === 'granted');

    constructor() {
      makeAutoObservable(this);
    }

    changeField = (field, value) => this[field] = value;

    setCurrentLanguage = (value) => this.currentLanguage = value;

    setSidebarOpenStatus = (value) => this.isSidebarOpened = value;

    toggleSidebar = () => this.isSidebarOpened = !this.isSidebarOpened;

    toggleRightSidebar = () => this.isRightSidebarOpened = !this.isRightSidebarOpened;

  ready = () => {
    this.isReady = true;
  }

  setNotificationStatus = (status) => runInAction(() => this.notificationStatus = status);
}

const appState = new AppState();

export default appState;
